package com.shadowings.gero.data.lessons.chapter11

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_complemento_oggetto_1
import gero.composeapp.generated.resources.exp_content_complemento_oggetto_2
import gero.composeapp.generated.resources.exp_content_complemento_oggetto_3
import gero.composeapp.generated.resources.exp_content_complemento_oggetto_4
import gero.composeapp.generated.resources.exp_content_complemento_oggetto_5
import gero.composeapp.generated.resources.exp_content_complemento_oggetto_6
import gero.composeapp.generated.resources.exp_content_complemento_oggetto_7
import gero.composeapp.generated.resources.exp_content_complemento_oggetto_8
import gero.composeapp.generated.resources.exp_title_complemento_oggetto

fun getFrasiComplOggettoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_complemento_oggetto,
            content = Res.string.exp_content_complemento_oggetto_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complemento_oggetto,
            content = Res.string.exp_content_complemento_oggetto_2,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complemento_oggetto,
            content = Res.string.exp_content_complemento_oggetto_3,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complemento_oggetto,
            content = Res.string.exp_content_complemento_oggetto_4,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complemento_oggetto,
            content = Res.string.exp_content_complemento_oggetto_5,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complemento_oggetto,
            content = Res.string.exp_content_complemento_oggetto_6,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complemento_oggetto,
            content = Res.string.exp_content_complemento_oggetto_7,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complemento_oggetto,
            content = Res.string.exp_content_complemento_oggetto_8,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
    )
}
